import React from 'react'
import { useTranslation } from 'next-i18next'
import style from '../../../styles/mystyle.module.css'
import config from '../../../next.config.js'
import Tab from "@mui/material/Tab"
import TabPanel from '@mui/lab/TabPanel'
import TabContext from '@mui/lab/TabContext'
import TabList from '@mui/lab/TabList'
import MainMenu from './MainMenu';
import { styled } from '@mui/system'
import { Navbar } from '../Layout/Navbar'
import Products from './Products'
import {CustomeTab ,CustomeSuperTab} from "./Tab.style"
// const CustomeSuperTab = styled(TabList)(({ theme, locale }) => ({
//     '& .MuiTabs-flexContainer': {
//         justifyContent: "stretch",
//         gap: "0rem"
//     },
//     '@media (min-width:768px) and (max-width:912px)': {

//         '& .MuiTabs-flexContainer': {
//             justifyContent: "space-evenly",
//             // gap: "3rem"
//         },
//     },
//     '@media (min-width:913px) ': {

//         '& .MuiTabs-flexContainer': {
//             justifyContent: "space-between",

//         },
//     },
// }))
// const CustomeTab = styled(Tab)(({ theme, locale }) => ({
//     color: "black",
//     minWidth: 0,
//     '&.Mui-selected': {
//         border: "0.5px solid #ccf0ef",
//         color: "#02AAB0 !important",
//         fontWeight: 600,
//         borderRadius: "12px ",
//         opacity: "1 !important",
//         backgroundColor: "white !important",
//     },
//     '& .MuiTabs-indicator': {

//         backgroundColor: "white",
//         height: "0"

//     },
//     '& .MuiTabs-flexContainer': {
//         justifyContent: "stretch",
//         gap: "0rem"
//     },


//     opacity: 0.5,
//     '@media (min-width:301px) and (max-width:767px)': {
//         fontSize: "0.9rem ",
//         width: "50%",
//     },



//     '@media (min-width:280px) and (max-width:300px)': {


//         fontSize: "0.7rem",
//         width: "50% !important",
//         minWidth: 0,

//     }
//     ,
//     '@media (min-width:768px) and (max-width:912px)': {

//         '& .MuiTabs-flexContainer': {
//             justifyContent: "space-evenly",
//             // gap: "3rem"
//         },

//         fontSize: "1rem",
//         width: "50%",
//     },
//     '@media (min-width:913px) ': {
//         '& .MuiTabs-flexContainer': {
//             justifyContent: "space-between",
//         },
//         fontSize: "1.2rem",
//         width: "50%",
//         opacity: 0.5,
//         height: "60px",
//     },

// }))

function TabOffers() {
    const [value, setvalue] = React.useState("1")
    const handleChange = (event, newValue) => {
        setvalue(newValue)
    }
    const { t } = useTranslation("common")
    return (
        <div className={style.ContainerMargin} style={{ backgroundColor: "white" }}>
        <Navbar exchangeAllCurrenciesCallBack={(res)=>(res)} currenciesCallBack={(res)=>(res)}>
            <div className={style.Container} >
                <div className={style.allcard}>
                    <div className={style.paddingRatingDiv}></div>
                    <div className={style.HeaderandBasketIconpagebasket} >
                        <div><img className={style.icontitle} src={`${config.basePath}/assest/sponsor.svg`} /></div>
                        <div className={style.textaboutdoctor1 + " " + style.Blod}  >{t("Advertising")}</div>
                    </div>
                    <div className={style.paddingRatingDiv}></div>
                    <TabContext value={value} >
                        <div >
                            <div className={style.paddingTabsBasket}>
                                <div className={style.stylesTabsBasket}>
                                    <CustomeSuperTab onChange={handleChange} TabIndicatorProps={{ style: { backgroundColor: 'white', height: "0" } }} >
                                        <CustomeTab 
                                        sx={{
                                            boxShadow: value == "4" ? "-7px 0px 9px 1px #bcbcbc " : "none",
                                        }}
                                   
                                        label={t("Products")}
                                        value="1" />
                                        <CustomeTab 
                                        sx={{
                                            boxShadow: value == "1" ? "5px 2px 9px 1px #bcbcbc" : "none",
                                        }}
                                           
                                        label={t("entityDetails")}
                                        value="4" />

                                    </CustomeSuperTab>   
                                    </div>
                                    </div></div>

                        <TabPanel padding="0px !important" value="1" sx={{ padding: 0 }} >
                            <Products typeCodeLst={["productUnitPrice", "product"]} product={true}/>

                        </TabPanel>
                     
                        <TabPanel padding="0px !important" value="4" sx={{ padding: 0 }} >
                            <MainMenu typeCodeLst={["entityDetails"]}/>
                        </TabPanel>

                    </TabContext>

                </div>

            </div>

            </Navbar>


</div>
    )
}

export default TabOffers
